import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import VeeValidate, { Validator } from "vee-validate";
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'
import ToggleButton from 'vue-js-toggle-button'
import LoadScript from 'vue-plugin-load-script';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import ptBr from "vee-validate/dist/locale/pt_BR";
import VueExcelXlsx from "vue-excel-xlsx";
import VueSingleSelect from "vue-single-select";

Vue.use(LoadScript);
Vue.use(VueFeather)
Vue.use(flatPickr)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(ToggleButton)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VeeValidate);
Validator.localize("pt_BR", ptBr);
Vue.use(VueMask)
Vue.use(VueExcelXlsx);

Vue.component('VSelect', vSelect)
Vue.component('ApexChart', VueApexCharts)
Vue.component('VueBootstrapTypeahead', VueBootstrapTypeahead)
Vue.component('VueSingleSelect', VueSingleSelect);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
